export const ROUTES = {
  "settings": "/settings",
  "my account": "/my-account",
  "my books": "/my-books",
  "my cartoons": "/my-cartoons",
  "cartoon": "/cartoons",
  "popular cartoons": "/cartoons",
  "popular books": "/products",
  "bestsellers": "/?scroll=bestsellers",
  "home": "/",
};